import {Stack} from '@mui/material'
import React from 'react'
import Label from './Label'
import FileIcon from '../../svg/File'

export default function StaticInputFile({width, text, file}: any) {
  return (
    <Stack
      gap='9px'
      direction={'row'}
      borderRadius={'6.18px'}
      p='5px'
      width={width}
      border='1px solid var(--bs-gray-300)'
    >
      <FileIcon />
      <Stack gap='2px'>
        <Label text={(file && file.name) || text || 'file'} fw='400' fs={'12px'} />
        {/* */}
        <Label
          color='#57595A'
          text={file && file.name ? ` ${file.name} KB` : ''}
          fw='400'
          fs={'8px'}
        />
      </Stack>
    </Stack>
  )
}
